import { IOneMessageDialogJson, IOneMessageJson } from "../../../../nodeserver/structs/database.js";
import { OneMessageElement} from "./helpers.js";

import { Message, NickName } from "../models/messages/message.js";
import { Websocket } from "../websocket.js";
import JSX from "../helpers/react.js";
import { Messages } from "./messages.js";
import { hasAnswer } from "../models/messages/actions/answer.js";
import {LoadingSpinner} from "../models/elements/index.js";

export class OneDialog {
    private readonly element: JQuery<HTMLElement>;
    private readonly lastMessageElement: JQuery;
    private readonly unreadCountElement: JQuery<HTMLSpanElement>;
    public readonly messages: OneMessageElement[] = [];
    private _loading: boolean = false;
    public fullLoaded: boolean = false;

    public get loading() {
        return this._loading
    }

    public set loading(value: boolean) {
        if (!(this._loading = value)) {
            this.$messagesContainer.children('.spinner').remove()
        } else if (this.messages.length) {
            $(<LoadingSpinner small={true} />).prependTo(this.$messagesContainer);
        }
    }

    constructor($element: JQuery<HTMLElement>, public readonly data: IOneMessageDialogJson, private readonly $messagesContainer: JQuery) {
        this.element = $element;
        this.unreadCountElement = $element.find('.unread-count-dialog');
        this.lastMessageElement = $element.find('.dialog-message-preview');
    }

    get messagesScrollBottom(): number {
        return (this.$messagesContainer.prop('scrollHeight') - this.$messagesContainer.prop('scrollTop')) as number;
    }

    set messagesScrollBottom(value: number) {
        const scrollHeight = this.$messagesContainer.prop('scrollHeight');
        this.$messagesContainer[0].scrollTo(0, scrollHeight - value);
    }

    set lastMessageText(value: string) {
        this.lastMessageElement.text(value);
    }

    get canReadMessages(): boolean {
        return this.messagesScrollBottom - this.$messagesContainer.height()! < 30
    }

    /**
     * Adds message to current dialog
     * @param message
     * @param end - when true adds to the end of dialog, false - to beginning
     */
    public addMessage(message: IOneMessageJson, end = false): boolean {
        if (this.messages.some(e => e.message.id === message.id)) return false;
        const prev_msg: OneMessageElement | null = end ? this.messages[this.messages.length - 1] : null,
            next_msg: OneMessageElement | null = end ? null : this.messages[0],
            $message = OneDialog.buildMessage(message, prev_msg, next_msg);
        const scroll = this.messagesScrollBottom;
        if (end) {
            const savePosition = !this.canReadMessages;
            this.$messagesContainer[0].appendChild($message);
            this.messages.push({message: message, element: $($message)});
            if (message.from_id == user_id)
                this.messagesScrollBottom = 0;
            else if (!savePosition)
                this.messagesScrollBottom = scroll;
        } else {
            this.$messagesContainer[0].prepend($message);
            this.messages.unshift({message: message, element: $($message)});
            this.messagesScrollBottom = scroll;
        }
        return true;
    }

    public clearMessages() {
        this.messages.splice(0, this.messages.length);
        this.$messagesContainer.find('.one-message').remove();
    }

    public get selected(): boolean {
        return this.element.hasClass('selected');
    }

    public set selected(value) {
        if (value) {
            this.element.addClass('selected');
            this.$messagesContainer?.addClass('shown');
            $('.messenger .message-textarea').val(localStorage['message_' + this.data.user_id]);
        } else {
            $('.messenger .message-textarea').val('');
            this.element.removeClass('selected');
            this.$messagesContainer?.removeClass('shown');
        }
    }

    public get messagesShown() {
        return this.$messagesContainer.hasClass('shown') && Messages.Instance?.messagesData?.hasClass('active');
    }

    public get unreadCount(): number {
        return this.data.unread_count;
    }

    public set unreadCount(value: number) {
        if (value) {
            this.element.addClass('unread');
            this.unreadCountElement.text(value + '');
        } else {
            this.element.removeClass('unread');
            this.unreadCountElement.text('');
        }
        this.data.unread_count = value;
    }

    public get banned(): boolean {
        return this.element.hasClass('banned');
    }

    public set banned(value: boolean) {
        if (value) this.element.addClass('banned');
        else this.element.removeClass('banned');
    }


    public static buildMessage(msg: IOneMessageJson, prev_msg: OneMessageElement | null, next_msg: OneMessageElement | null): HTMLElement {
        const classes = ['one-message'];
        const isAnswer = hasAnswer(msg);
        if (!isAnswer && prev_msg?.message?.from_id === msg.from_id) {
            classes.push('no-ava');
            if (msg.date - prev_msg!.message!.date < 3 * 60) classes.push('no-date');
        }
        if (user_nickname && msg.text.includes('@' + user_nickname)) {
            classes.push('mention');
        }
        if (!msg.read) classes.push('unread');

        if (isAnswer)
            classes.push("answer");


        const html = (<Message classes={classes} msg={msg}></Message>)


        if (next_msg?.message?.from_id === msg.from_id) {
            if (next_msg!.message.date - msg.date < 3 * 60 && !next_msg.element.hasClass("answer")) {
                next_msg.element.addClass('no-date');
                next_msg.element.addClass('no-ava');
            }
        }
        return html;
    }


    private static buildMessageDialog(dialog: IOneMessageDialogJson): HTMLElement {

        let classes = `message-dialog${dialog.banned ? ' banned' : ''}${dialog.unread_count ? ' unread' : ''}`;

        const html = (
            <div className={classes} data-uid={dialog.user_id}>
                <a href={`#messages${dialog.user_id}`} className="dialog-img bordered">
                    <img src={dialog.avatars.big} style={{"--small": `url(${dialog.avatars.small})`}} loading="lazy"
                         alt=""/>
                    <span className="ban-user fa fa-ban"/>
                </a>
                <div className="dialog-data">
                    <div className="dialog-head">
                        <NickName roles={dialog.roles ?? []} userId={dialog.user_id} nickname={dialog.nickname}
                                  toId={0}/>
                        <span className="badge unread-count-dialog">{dialog.unread_count || ''}</span>
                    </div>
                    <div className="dialog-message-preview">
                        {dialog.last_message}
                    </div>
                </div>
            </div>
        );

        return html;
    }


    public static create(data: IOneMessageDialogJson, append: 'append' | 'prepend' = 'append'): OneDialog {
        const dialogHtml = this.buildMessageDialog(data),
            messagesContainer = $(<div className="messages-with-user" data-uid={data.user_id}/>)
                .appendTo(Messages.Instance!.messagesContainer)
                .on('scroll', async () => {
                    const scroll: number = messagesContainer.scrollTop() ?? 999;
                    if (scroll < 200)
                        await Messages.Instance!.loadMoreMessages($(dialogHtml).data('dialog') as OneDialog);
                    if (ans.canReadMessages && ans.unreadCount > 0 && ans.messages[ans.messages.length - 1]?.message?.to_id == user_id) {
                        Websocket.Instance.readMessages(data.user_id);
                        ans.data.unread_count = 0;
                    }
                });
        if (append == 'append') $(dialogHtml).appendTo('.dialogs-container');
        else if (append == 'prepend') $(dialogHtml).prependTo('.dialogs-container');
        const ans = new OneDialog($(dialogHtml), data, messagesContainer);
        $(dialogHtml).data('dialog', ans);
        return ans;
    }
}